import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, map} from 'rxjs';
import {environment} from '../../environments/environment';

/**
 * Mode maintenance du portail.
 *
 * Contrat d'API attendu côté backend (non encore implémenté) :
 *
 *   GET /api/v1/maintenance
 *     -> 200 { "enabled": boolean }   (utilisateur authentifié)
 *
 *   PUT /api/v1/maintenance
 *     corps : { "enabled": boolean }
 *     -> 200 { "enabled": boolean }   (rôle gestionnaire uniquement, enforcement côté backend)
 *
 * Tant que l'endpoint n'existe pas, les appels échouent (404) et le frontend
 * reste en comportement nominal (échec silencieux = maintenance inactive).
 */
@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  private http = inject(HttpClient);

  isEnabled(): Observable<boolean> {
    return this.http.get<{ enabled: boolean }>(`${environment.backend}/maintenance`)
      .pipe(map(state => state.enabled));
  }

  setEnabled(enabled: boolean): Observable<boolean> {
    return this.http.put<{ enabled: boolean }>(`${environment.backend}/maintenance`, {enabled})
      .pipe(map(state => state.enabled));
  }
}
